export default "__VITE_ASSET__86e731e9__"